import { StyleSheet, View } from 'react-native';

import { tokens } from '../../tokens';
import { IconErrorFill, IconInfoFill, IconWarningFill } from '../icon';
import { XStack } from '../stack';
import { Text } from '../text';

type InlineAlertType = 'info' | 'warning' | 'error';

type InlineAlertProps = {
  type: InlineAlertType;
  message: string;
};

const backgroundColorByStatus = {
  info: '$houseLight',
  warning: '$warningBackground',
  error: '$errorBackground',
};

const iconByStatus = {
  info: <IconInfoFill size={20} />,
  warning: <IconWarningFill size={20} />,
  error: <IconErrorFill size={20} />,
};

export function InlineAlert(props: InlineAlertProps) {
  const backgroundColor = tokens.colors[backgroundColorByStatus[props.type]];
  const backgroundColorStyle = {
    backgroundColor,
  };

  return (
    <XStack style={[styles.container, backgroundColorStyle]}>
      <View>{iconByStatus[props.type]}</View>
      <Text style={styles.message}>{props.message}</Text>
    </XStack>
  );
}

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: 16,
    paddingVertical: 12,
    borderRadius: 8,
    gap: 8,
    alignItems: 'center',
  },
  message: {
    fontSize: 12,
    lineHeight: 16.8,
  },
});
